<template>
  <el-form :model="searchForm" size="mini" :inline="true" :rules="formRules">
    <el-col :span="3">
      <el-form-item prop="operatorId">
        <el-cascader  size="mini" clearable  ref="cascader"
                      placeholder="运营商"
                      :options="operatorTree"
                      :props="{ checkStrictly:true,expandTrigger:'hover'}"
                      :show-all-levels="false"
                      change-on-select
                      @change='handleChangeOperator'
                      v-model="searchForm.operatorId">
        </el-cascader>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="stationCode">
        <el-select placeholder="所属站" v-model="searchForm.stationCode" clearable>
          <el-option v-for="item in stationsForSelect" :key="item.stationCode"
                     v-bind:label="item.stationName" v-bind:value="item.stationCode"></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="appointName">
        <el-input placeholder="预约名称" v-model="searchForm.appointName" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="beginTime">
        <el-date-picker
          v-model="searchForm.beginTime"
          type="date"
          placeholder="开始时间"
          value-format="yyyyMMddHHmmss"
          :picker-options="dateOps"
          :style="{width: '100%'}">
        </el-date-picker>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="endTime">
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="结束时间"
          value-format="yyyyMMddHHmmss"
          :picker-options="dateOps"
          :style="{width: '100%'}">
        </el-date-picker>
      </el-form-item>
    </el-col>

    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetForm">清空</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitForm"
                   :loading="loading">查询
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import {validateInput} from '../../../../../common/validator'

  export default {
    name: "search",
    data() {
      const validEndTime = (rule, value, callback) => {
        if (!this.searchForm.beginTime || !this.searchForm.endTime) {
          return callback()
        } else if (this.searchForm.endTime - this.searchForm.beginTime < 0) {
          return callback('开始时间必须小于结束时间')
        } else {
          return callback()
        }
      }
      return {
        formRules: {
          appointName: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
          beginTime: [{validator: validEndTime, trigger: 'change'}],
          endTime: [{validator: validEndTime, trigger: 'change'}]
        },
        dateOps: {
          shortcuts: [{
            text: '一个月前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }, {
            text: '一个月后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', date);
            }
          }]
        }
      }
    },
    props:{
      searchForm:{},
      stationsForSelect: {
        type: Array,
        required: true
      },
      operatorTree:{
        type: Array,
        required: true
      },
      loading: false,
    },
    methods: {
      resetForm() {
        for(let item in this.searchForm) {
          if(this.searchForm[item]){
            this.searchForm[item] = ''
          }
        }
        this.submitForm()
      },
      handleChangeOperator(value) {
        let operatorId = value &&value.length >0 ? value[value.length-1] : ''
        this.searchForm.operatorId= operatorId
        this.$refs.cascader.dropDownVisible = false
        this.$emit("operatorSelect", operatorId)
      },
      submitForm(){
        this.$emit("submitForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/appointmentManager/appointmentSettings/search.vue